import axios from "axios";

export const getInbox = async (source) => {
  const response = await axios.get("/api/notifications/inbox", {
    cancelToken: source.token,
  });
  return response.data;
};

export const getNotifications = async (page, source) => {
  const response = await axios.get("/api/notifications/inbox/messages", {
    cancelToken: source.token,
    params: { sort: '-createdAt', page }
  });
  return response.data;
};

export const getUnreadNotifications = async (page, source) => {
  const response = await axios.get("/api/notifications/inbox/messages", {
    cancelToken: source.token,
    params: { sort: '-createdAt', page, status: 'unread' }
  });
  return response.data;
};

export const setReadStatus = async (pref, source) => {
  const response = await axios.patch(`/api/notifications/messages/${pref}`, { status: "read" }, {
    cancelToken: source.token,
  });
  return response.data;
};

export const addNotificationsPreference = async (pref, source) => {
  const response = await axios.post(`/api/preferences/contextpreferences`, pref, { cancelToken: source.token });
  return response.data;
}

export const registerNotificationTokenForUser = async ({userId, registrationToken}, source) => {
  const currentRegistration = await axios.get(`/api/push/registrations?userId=${userId}&applicationId=int-continuous.a-todo-prod.v1`, { cancelToken: source.token });
  if (currentRegistration.data._embedded?.registrations?.length > 0) {
    const response = await axios.patch(`/api/push/registrations/${currentRegistration.data._embedded.registrations[0].id}`, {
      registrationToken,
      userId
    }, { cancelToken: source.token })
    return response.data;
  } else {
    const response = await axios.post(`/api/push/registrations`, {
      registrationToken,
      userId
    }, { cancelToken: source.token });
    return response.data;
  }
}

export const removeNotificationsPreference = async (pref, source) => {
  const response = await axios.delete(`/api/preferences/contextpreferences/${pref.id}`, { cancelToken: source.token });
  return response.data;
}

export const getNotificationsPreferences = async (userId, source) => {
  const contextsResponse = await axios.get(
    "/api/preferences/contexts?pagesize=1000",
    {
      cancelToken: source.token,
    }
  );

  const contextPreferencesResponse = await axios.get(
    `/api/preferences/contextpreferences?userId=${userId}&pagesize=1000`,
    {
      cancelToken: source.token,
    }
  );

  // Simplify returned data
  const contexts = contextsResponse.data._embedded.contexts.filter(context => context.whitelist !== null);
  const contextPreferences = contextPreferencesResponse.data._embedded.contextPreferences;

  // Supported channels
  const supportedChannels = ['email', 'inApp', 'push'];

  // Available contexts
  const allPreferences = contexts
    .filter(context => context.defaultChannel === 'opt-out' && context.whitelist !== null)
    .map(c => ({
      name: c.name,
      supportedChannels: c.supportedChannels,
    }))
    .reduce((all, context) => {
      const obj = context.supportedChannels.reduce((acc, value) => {
        if(supportedChannels.includes(value)) {
          if (acc.hasOwnProperty(value)) {
            acc[value].push(context.name);
          } else {
            acc[value] = [context.name];
          }
        }
        return acc;
      }, all);

      return obj;
    }, {});

  // My contexts
  const myPreferences = contextPreferences
    .filter(item => item.isSubscribed)
    .map(pref => ({
      id: pref.id,
      channel: pref.channel,
      name: pref._embedded.context.name,
      isSubscribed: pref.isSubscribed,
    }))
    .reduce((acc, value) => {
      acc[value.channel] = acc[value.channel] || [];
      acc[value.channel].push({
        name: value.name,
        id: value.id,
      });
      return acc;
    }, {});

  return {
    allPreferences: allPreferences,
    myPreferences: myPreferences,
  };
};
